import { render, staticRenderFns } from "./Abnahmen.vue?vue&type=template&id=57492763&scoped=true&"
import script from "./Abnahmen.vue?vue&type=script&lang=js&"
export * from "./Abnahmen.vue?vue&type=script&lang=js&"
import style0 from "./Abnahmen.vue?vue&type=style&index=0&id=57492763&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57492763",
  null
  
)

export default component.exports